<template>
  <div :style="'background-color:' + tertiaryColor" class="box">
    <div class="columns">
      <div class="column has-text-centered">
        <b-button size="is-medium" class="mr-6" type="is-primary">
          {{ $t("login") }}
        </b-button>
      </div>
      <div class="column has-text-centered">
        <b-button size="is-medium" class="mr-6" type="is-link">
          {{ $t("login") }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BrandingResults",
  computed: {
    primaryColor() {
      return this.$store.state.draft.branding.primaryColor;
    },
    secondaryColor: {
      get() {
        return this.$store.state.draft.branding.secondaryColor;
      },
    },
    tertiaryColor: {
      get() {
        return this.$store.state.draft.branding.tertiaryColor;
      },
    },
    fourthColor: {
      get() {
        return this.$store.state.draft.branding.fourthColor;
      },
    },
  },
};
</script>

<style></style>
